// extracted by mini-css-extract-plugin
export default {"edited-value-bullet":"components-settings-budget-forecast-settings-page-module__edited-value-bullet"};